module.exports = __webpack_public_path__ + "img/phone.2e44d914.svg";